/* SystemSettings.js */

"use strict";
//const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "system_settings",
    label: "Settings",
    disabled: false,
    app: "GameConsole",
    section: "Settings",
    license: [],
    accessPerm: [],
    pageTitle: "Gluware System Settings",
    helpLink: "Settings/System-Settings-overview.htm",
    navIcon: "settings.solution",
    iconName: "branding.systemSettings",
    navOptions: {
        system: {
            name: "Global",
            options: {
                sr: "Global/ProductInformation",
            },
            type: "exp",
            helpLink: "Settings/Global-Product-Information-screen.htm",
        },
        organization: {
            name: "Organization",
            options: {
                sr: "Organization/CustomFields",
            },
            type: "exp",
            helpLink: "Settings/Organization-Custom-Fields.htm",
        },
        user: {
            name: "User",
            steve2Path: "/frontend/settings/users/management",
            options: {},
            checkPerm: true,
            perms: ["userRead"],
            type: "exp",
            helpLink: "Settings/User-My-Profile-screen.htm",
        },
        credentials: {
            name: "Credentials",
            steve2Path: "/frontend/settings/credentials/management",
            options: {},
            checkPerm: true,
            perms: ["credentialsAccess"],
            type: "exp",
            helpLink: "Settings/Manage-credentials.htm",
        },
        titanAi: {
            name: "Titan AI",
            steve2Path: "/frontend/settings/titan-ai",
            options: {},
            perms: ["accessTitanSettings"],
            type: "exp",
        },
    },
};
